export default {"src":"/_next/static/media/ship-play-text-only.6c0f5a8c.svg","height":20,"width":86,"blurWidth":0,"blurHeight":0};